import React, { useEffect, useState } from 'react';
import { useListContext } from 'react-admin';
import { ArrowDropDown, SortRounded } from '@mui/icons-material';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { Box, Button, IconButton, Menu, MenuItem } from '@mui/material';
import { find } from 'lodash';

type OptionType = {
	id: string;
	label: string;
};

export const SortButton = ({ options }: { options: OptionType[] }) => {
	const { setSort, sort } = useListContext();
	const { order, field } = sort;
	const [buttonLabel, setButtonLabel] = useState('');

	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => setAnchorEl(null);

	const handleSort = ({ id, label }: { id: string; label: string }) => {
		setSort({ field: id, order });
		setButtonLabel(label);
		handleClose();
	};

	const handleOrderChange = (currentOrder: 'ASC' | 'DESC') => {
		setSort({ order: currentOrder, field });
	};

	useEffect(() => {
		setButtonLabel(find(options, ['id', field])?.label || '');
	}, []);

	return (
		<Box
			sx={{ border: '1px solid', borderRadius: 1, borderColor: 'primary.main' }}
		>
			<Button
				aria-controls="simple-menu"
				aria-haspopup="true"
				color="primary"
				startIcon={<SortRounded />}
				size="small"
				onClick={handleClick}
			>
				{buttonLabel}
			</Button>
			<IconButton
				size="small"
				onClick={() => handleOrderChange('ASC')}
				color={order === 'ASC' ? 'primary' : 'default'}
			>
				<ArrowUpwardIcon fontSize="small" />
			</IconButton>

			<IconButton
				size="small"
				onClick={() => handleOrderChange('DESC')}
				color={order === 'DESC' ? 'primary' : 'default'}
			>
				<ArrowDownwardIcon fontSize="small" />
			</IconButton>
			<Menu open={!!anchorEl} anchorEl={anchorEl} onClose={handleClose}>
				{options.map((opt, i) => (
					<MenuItem key={`${opt.id}-${i}`} onClick={() => handleSort(opt)}>
						{opt.label}
					</MenuItem>
				))}
			</Menu>
		</Box>
	);
};
